import {Dispatch, SetStateAction} from "react";
import {TaxInvoiceListElementType, TaxInvoiceSearchParamType} from "../interface";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {SubmitHandler, useForm} from "react-hook-form";

interface PropsType {
    searchParam: TaxInvoiceSearchParamType;
    setSearchParam: Dispatch<SetStateAction<TaxInvoiceSearchParamType>>;
    setSelectedItems: Dispatch<SetStateAction<TaxInvoiceListElementType[]>>
}

export default function Filter({searchParam, setSearchParam, setSelectedItems}: PropsType) {
    const {goToNavigation} = useGoToNavigation();

    const {register, handleSubmit, watch} = useForm({
        defaultValues: searchParam,
    });

    const onSubmit: SubmitHandler<TaxInvoiceSearchParamType> = (submitData) => {
        goToNavigation(`order/invoice/list?pageNo=1`, {}, false);
        setSearchParam({...submitData, pageNo: 1});
        setSelectedItems([])
    };

    return (
        <div className="fiter_wrap">
            <div className="fiter_top">
                <h3 className="filter_heading">세금계산서 검색</h3>
                <div className="filter_toolbar"></div>
            </div>
            <form className="row" onSubmit={handleSubmit(onSubmit)}>
                <div className="col-6">
                    <div className="frm_row search justify-content-start">
                        <label className="form-label frm_label">상태</label>
                        <select
                            className="form-select w-150px"
                            value={watch("taxFlag")}
                            {...register("taxFlag")}
                        >
                            <option value="0">전체</option>
                            <option value="Y">발행</option>
                            <option value="N">발행 요청</option>
                        </select>
                    </div>
                </div>
                <div className="col-6">
                    <div className="frm_row">
                        <label className="form-label frm_label">발행일자</label>
                        <div className="frm_field input_date">
                            <input
                                type="date"
                                className="form-control"
                                value={watch("fromDate")}
                                {...register("fromDate")}
                            />
                            <span className="txt_range">~</span>
                            <input
                                type="date"
                                className="form-control"
                                value={watch("toDate")}
                                {...register("toDate")}
                            />
                            <button className="btn btn-info btn_search">
                                <img
                                    src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                                    alt=""
                                />
                                조회
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
